import styled from 'styled-components';

export const Loaded = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
  white-space: nowrap;
`;

export const ProgressWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  background: #ccc;
  cursor: pointer;
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: #616161;
`;

export const Thumb = styled.div`
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  background: white;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  cursor: grab;
  transition: transform 0.1s ease-in-out;

  &:active {
    transform: translate(-50%, -50%) scale(1.2);
  }
`;

export const VolumeContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const VolumeButton = styled.div`
  width: 40px;
  height: 40px;
  background: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  &:hover + div {
    opacity: 1;
    visibility: visible;
  }
`;

export const VolumeControl = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  width: 60px;
  height: 143px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;

  &:hover {
    opacity: 1;
    visibility: visible;
  }
`;

export const VolumeSlider = styled.input.attrs({ type: 'range' })`
  width: 4px;
  height: 96px;
  appearance: none;
  background: transparent;
  cursor: pointer;
  touch-action: none;

  /* Đảo chiều thanh kéo */
  writing-mode: vertical-lr;
  direction: rtl;

  &::-webkit-slider-runnable-track {
    width: 4px;
    height: 96px;
    border-radius: 8px;
    cursor: pointer;
    background: linear-gradient(
      to top,
      var(--ant-primary-color) ${(props) => Number(props.value) * 100}%,
      #d1d5db ${(props) => Number(props.value) * 100}%
    );
  }

  /* Thumb (nút kéo) */
  &::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    background: var(--ant-primary-color);
    border-radius: 50%;
    cursor: pointer;
    margin-left: -4px;
  }

  /* Thanh đã kéo qua */
  &::-moz-range-progress {
    background: var(--ant-primary-color);
    height: 100%;
    border-radius: 8px;
  }
`;

export const SpeedContainer = styled.div`
  select {
    padding: 4px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    background: transparent;
    cursor: pointer;
  }
`;
